import styled from "styled-components";
import { media, breakpoints } from "../../../theme";

/**
 * MATRİS/IZGARA TABLOLAR İÇİN YATAY KAYDIRMA KUTUSU.
 *
 * `DataTable`'ın kart kipine geçmeyen tablolar burayı kullanır. Hangileri:
 * rota matrisi, personel atama ızgarası, haftalık düzen düzenleyicisi ve
 * kurulum listeleri. NEDEN KART DEĞİL: bu tablolarda anlam satırda değil
 * satır-sütun KESİŞİMİNDE ("2. hafta A ekibi gece"). Satırı dikey karta açmak
 * matrisi okunmaz hâle getirir; doğru cevap kaydırmadır.
 *
 * Kaydırma SAYFAYI değil kendi kutusunu kaydırır — kabuk (App.tsx) yatay
 * kaydırmaya kapalı, taşan tablo yoksa sayfa hiç yana kaymaz.
 *
 * `$minWidth`: dar ekranda tablonun sıkışıp harf harf sarmasını engeller.
 * Varsayılan 720px; kolonu az olan tablolar daha küçük verebilir.
 */
const ScrollBox = styled.div<{ $minWidth?: number }>`
  width: 100%;
  overflow-x: auto;
  /* iOS'ta ivmeli kaydırma. */
  -webkit-overflow-scrolling: touch;

  ${media.mobile} {
    table {
      min-width: ${(p) => p.$minWidth ?? 720}px;
    }
  }

  /* Kaydırma çubuğu masaüstünde görünmesin, dokunmatikte zaten gizli. */
  @media (min-width: ${breakpoints.mobile + 1}px) {
    scrollbar-width: thin;
  }
`;

export default ScrollBox;
